"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderedCatalogsList = exports.CatalogsOrderLayoutWrap = exports.OrderModal = exports.OrderedCatalogDescription = exports.OrderedCatalogsHeading = exports.OpenOrderModalButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
exports.OpenOrderModalButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton)((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'fixed',
    right: '-2px',
    top: '15%',
    px: 3,
    zIndex: 1,
    '.counter': {
        top: 0,
        left: 0,
        transform: 'translate(-50%, -50%)',
    },
}));
exports.OrderedCatalogsHeading = styled_components_1.default.h2((0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.text.groupHeading, ({ theme }) => theme.catalogs.catalogsOrderHeading));
exports.OrderedCatalogDescription = styled_components_1.default.p((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: ['100%', '70%'],
    fontSize: 0,
    color: 'textGray',
    mb: ['20px', 4],
    px: [2, 0],
}));
exports.OrderModal = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    name: 'orderModal',
    fullScreen: true,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.modal-body': {
        p: [4, '40px'],
    },
    '.modal-wrapper': {
        variant: 'modals.wideModalWrapper',
    },
}));
exports.CatalogsOrderLayoutWrap = styled_components_1.default.section(({ theme }) => theme.catalogs.catalogsOrderLayoutWrap);
exports.OrderedCatalogsList = styled_components_1.default.div(({ theme }) => theme.catalogs.catalogsOrderedCatalogsList);
//# sourceMappingURL=fdr-catalogs-order-layout.styles.js.map